export const accountStatementTableColumns = [
  "DATE",
  "TRANSACTION",
  "EVENT",
  "MARKET TYPE",
  "CREDIT/DEBIT",
  "CLOSE BALANCE",
  "TRANSACTION ID",
  "ACTION",
];

export const myBetTableColumns = [
  "DATE",
  "EVENT",
  "MARKET",
  "BET",
  "ODDS",
  "AMOUNT",
  "STATUS",
  "RETURNS",
  "BET TYPE",
];

export const bettingProfitLossTableColumns = [
  "MARKET",
  "START TIME",
  "SETTLED TIME",
  "COMMISSION",
  "NET WIN",
  // "ACTION",
];

export const myWalletTableColumns = [
  "DATE",
  "TRANSACTION",
  "CREDIT/DEBIT",
  "BALANCE",
  "DESCRIPTION",
];

export const turnoverHistoryTableColumns = [
  "EVENT DATE",
  "EVENT NAME",
  "TRANSACTION TYPE",
  "MARKET",
  "MARKET TYPE",
  "AMOUNT",
  "TURNOVER BALANCE",
];

export const BonusStatementTableColumns = [
  "BONUS TYPE",
  "APPROVAL DATE",
  "AWARDED DATE",
  "AWARDED AMOUNT",
  "TURNOVER ",
  "INSTALLMENTS",
  "REDEEMED AMOUNT",
  "STATUS",
  "LAST DATE",
  "EXPIRY DATE",
];

export const myTransactionsTableColumns = [
  "TRANSACTION TIME",
  "TRANSACTION ID",
  "TRANSACTION TYPE",
  "AMOUNT",
  "APPROVED AMOUNT",
  "TRANSACTION STATUS",
  "NOTES",
  "PAYMENT METHOD",
];

export  const depositTurnoverTableColumns = [
    "Transaction Time",
    "Amount",
    "Cashable Amount",
    "Turnover",
    "Status",
     "Redeemed Date",
    "Update Time",
]

export const CONFIG_PERMISSIONS = {
  football: 1,
  tennis: 2,
  cricket: 4,
  live_casino: 8,
  indian_casino: 16,
  sports: 7,
  casino: 24,
  commission: 32,
  crypto_currency: 64,
  binary: 128,
};
